import React from "react";
import { compose } from "recompose";
import { withApollo } from "react-apollo";
import { getDeviceInfo } from "../../utils/functions";
import { registerScanCode } from "../../graphQl/mutations/affiliate";
import { Spin } from "antd";

class QRRedirectPage extends React.Component {

  redirectToUrl(url = "https://www.chazki.com/") {
    window.location.replace(url);
  }

  componentDidMount() {
    const { affiliateID } = this.props;

    if (affiliateID) {
      const deviceInfo = getDeviceInfo();

      this.props.client
        .mutate({
          mutation: registerScanCode,
          variables: {
            affiliateID,
            deviceInfo,
          },
        })
        .then(response => {
          const { data: { registerAffiliateQRScan } } = response;

          console.log("registerAffiliateQRScan response:", registerAffiliateQRScan);
          const urlLink = registerAffiliateQRScan?.extra?.urlLink;
          if (urlLink) {
            this.redirectToUrl(urlLink);
          } else {
            this.redirectToUrl();
          }
        })
        .catch(err => {
          this.redirectToUrl();
        });
    } else {
      this.redirectToUrl();
    }
  }

  render() {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#f5f7fa",
          padding: "20px",
        }}
      >
        <div
          style={{
            maxWidth: "420px",
            width: "100%",
            background: "#ffffff",
            borderRadius: "12px",
            padding: "40px 32px",
            textAlign: "center",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          }}
        >
          <Spin size="large" />
          <h2
            style={{
              marginTop: "24px",
              color: "#2b2b2b",
            }}
          >
            Redireccionando...
          </h2>

          <p
            style={{
              color: "#666",
              marginTop: "12px",
              lineHeight: 1.6,
            }}
          >
            Estamos preparando la encuesta de satisfacción.
            <br />
            En unos segundos podrás compartir tu experiencia con nuestro servicio.
          </p>
        </div>
      </div>
    );
  }
}

export default compose(withApollo)(QRRedirectPage);
